import TemplateView from "../../../TemplateView";

export default class GroupBlock extends TemplateView {
    constructor($containerEl, {title = "", items = []}) {
        super($containerEl);
        this.title = title;
        this.items = items;
    }

    templateHtml() {
        return "<div class='groupSection components_itemGroup'>" +
               "  <div class='header'><%=title.toUpperCase()%></div>" +
               "  <div class='items'></div>" +
               "</div>"
    }

    afterRender() {
        const $items = this.find(".items");
        this.items.forEach(item => item.init($items));
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/usersAssignedToHierarchy/usersList/GroupBlock.js